import { IModel_roles } from "../website/types/schema"
type AllowedAttributes = keyof IModel_roles
export const roleSettings = [
  "isAdmin",
  "isAccounts",
  "canManageProducts",
  "canManageConsignmentProducts",
  "canViewCRM",
  "canViewBranchReports",
  "can_set_site_banner_message",
  "canEditLinkTooltips",
  "canGuestLoginToCustomerAccounts",
  "canEditCustomersPricing",
  "canDispatchCashSalesOrderWithNoCreditLimit",
  "canManageNamedPriceBands",
  "canManageUniversalPricing",
  "canManageSharedPriceBands",
  "canUpdateManagingUsersOnSharePriceBands",
  "canUpdateManagingUsersOnPriceBands",
  "customer_view_only",
  "canViewCustomerStatements",
  "canManageCRMPermissions",
  "canManageHRPermissions",
  "canApproveByPassMinMargins",
  "canApproveElevatedMinPriceBypass",
  "canBypassSpendLimitOnNewBusiness",
  "canManageSalesRepTargets",
  "canManageBranchTargets",
  "can_create_manual_invoice_items",
  "can_approve_manual_invoice_items",
  "canEditBranchSettings",
  "canUseNonPriceBandPricesOnQuotesOrders",
  "canViewGlobalMasterPriceImports",
  "canRunSageImports",
  "canSetPricesBelowMinimumMargins",
  "canManageSupportTicketSettings",
  "canManageStockTakes",
  "canDispatchOverCreditLimitOrders",
  "canGrantReportPermissions",
  "canCreateStockTransfers",
  "canDeletePriceBands",
  "canDeleteUniversalPriceBands",
  "canCopyPriceBandsInterBranch",
  "canExportCustomers",
  "canMigrateSalesRepInvoiceItems",
  "canManageBuyingGroups",
  "canArchiveQuotes",
  "canArchiveOrders",
  "canCreateSageProducts",
  "canEditExistingProducts",
  "canExportNewProducts",
  "canDeleteUnexportedProducts",
  "canManageProductMasterTags",
  "canAssignProductMasterTags",
  "canManageSalesRestrictions",
  "hrAreaOnly",
  "canManageHolidayRequests",
  "isHrAdmin",
  "canManageSalesRepAssignments",
  "canSendBulkEmails",
  "canViewOtherUsersEvents",
  "canViewFortusLiveAccounts",
  "canManageCustomerTags",
  "canAssignCustomerTags",
  "canViewCustomerLists",
  "canEditGlobalUserPermissions",
  "canAccessSystemSettings",
  "canManageBetaFeatureAccess",
  "canViewPreviewFeatures",
  "canUpdatePurchaseOrdersInSage",
  "canEditOrderRequests",
  "canShuntOrderRequests",
  "canViewInternalTickets",
  "can_manage_sage_auth",
  "can_manage_customer_slide_show",
  "canViewAllSalesRepsInReports",
  "canExportPurchaseOrdersToSage",
  "canDespatchOrdersInSage",
  "accessible_reports",
  "canManageRoles",
] as const

// Fails to compile if a setting above isn't an attribute on roles.
const _allRoleAttributes: readonly AllowedAttributes[] = roleSettings

export type IRoleSetting = Exclude<
  (typeof roleSettings)[number],
  "id" | "name" | "created_at" | "updated_at" | "users"
>

export function skeemUserRoleSetting(setting: IRoleSetting) {
  return {
    as: setting,
    value: {
      if: [
        { eq: [{ count: { path: ["role"] } }, { value: 1 }] },
        { path: ["role", setting] },
        { attr: setting },
      ],
    },
  }
}

// Strips unwanted fields such as those from user records that are combined in this form
// like accessible branches
export function permittedRoleData(data: Record<string, any>) {
  const roleDataKeys = ["name", ...roleSettings]
  const permittedData = Object.entries(data).reduce((acc, key) => {
    if (roleDataKeys.includes(key[0])) {
      acc[key[0]] = key[1]
    }
    return acc
  }, {} as Record<string, any>)
  return permittedData
}

export function excludeRoleData(data: Record<string, any>) {
  const clone = { ...data }
  roleSettings.forEach(setting => {
    delete clone[setting]
  })
  return clone
}

export function replaceRoleSettings(data: Record<string, any>, roleData: Record<string, any>) {
  roleSettings.forEach(setting => {
    data[setting] = roleData[setting]
  })
  return data
}
